import { gql } from 'apollo-boost';

export const MenuForPos = gql`
  query MenuForPos($shopId: Int!) {
    menu(shopId: $shopId) {
      menuGroups {
        menuGrpId
        menuGrpNm
        menuItems {
          menuItemId
          menuItemNm
          menuItemThumbImgUrl
          menuItemSquareImgUrl
          soldoutYn
        }
      }
    }
  }
`;

export const UpdateMenuItemSoldoutYn = gql`
  mutation UpdateMenuItemSoldoutYn($menuItemId: Int!, $soldoutYn: Boolean!) {
    updateMenuItemSoldoutYn(menuItemId: $menuItemId, soldoutYn: $soldoutYn)
  }
`;
